<template>
  <div class="settings">
    <img :src="logoSrc" @click="callDevTool" class="logo-img" />
    <br />
    <div class="info">
      <h2>{{ title }}</h2>
    </div>
    <br />
    <div class="info" @click="dialogVisible = true">
      <div style="display: inline-block">
        <h3>{{ $t("langcfg.txtVersion") }}: {{ version }}</h3>
      </div>
      <div style="display: inline-block">
        <h3>
          <span
            class="iconfont icon-upload"
            style="font-size: 25px; color: yellow"
            v-if="isUpdateNeeded"
          ></span>
        </h3>
      </div>
    </div>

    <!-- <div style="display: inline-block">
      <h3 v-html="systemVersion"></h3>
    </div> -->
    <br />
    <h4 v-html="copyright" class="copyright"></h4>
    <br />
    <h4 class="copyright">All Rights Reserved</h4>
    <Update
      :dialogVisible.sync="dialogVisible"
      :uid="uid"
      :updateInfo="updateInfo"
      @save="saveUpdateInfo"
      @update="reqVersion(false)"
      @close-update-tip="closeUpdateTip"
    />
  </div>
</template>
<script>
import Update from "./Update";
import version from "../../../assets/version.json";
import { reqGet, reqGetPip } from "../../../services/httpreq";
import { saveUpdateSettings } from "../../../settings";
import fileSys from "../../../fileoprators/fileSystem";
import { License, Message } from "../../../mixins";
import moment from "moment";
import { isDefined, json2string, string2json } from "../../../shared/utils";
const exec = window.require("child_process").exec;
export default {
  name: "About",
  data() {
    return {
      version: "R1.0",
      endYear: "2023",
      logoSrc: require("../../../assets/img/logo.png"),
      dialogVisible: false,
      uid: "",
      isUpdateNeeded: false,
      dispCnt: 0,
      updateInfo: {
        ip: "",
        port: "",
        path: ""
      },
      key: "domestic",
      systemVersion: "",
      lang: {
        UpdateApp: this.$t("langcfg.txtUpdateApp"),
        DownLoading: this.$t("langcfg.txtDownLoading"),
        Setuping: this.$t("langcfg.txtSetuping"),
        SetupEnd: this.$t("langcfg.txtSetupEnd"),
        UpdateFailed: this.$t("langcfg.txtUpdateFailed")
      }
    };
  },
  mixins: [License, Message],
  created() {
    this.version = version.version;
    this.uid = window.uid;
    this.key = window.settings.language === "zh_CN" ? "domestic" : "foreign";
    let ver = fileSys.getSystemVersion();
    this.systemVersion = isDefined(ver) ? `<br />${this.$t("langcfg.txtSystem")}: ${ver}` : "";
    this.endYear =
      Number(this.endYear) <= Number(moment().format("YYYY"))
        ? moment().format("YYYY")
        : this.endYear;
    this.reqVersion();
  },
  mounted() {
    this.dialogVisible = this.isUpdate && window.updateSettings.isUpdateTipVisible;
  },
  props: {
    isUpdate: false
  },
  methods: {
    reqVersion(check = true) {
      this.updateInfo = window.updateSettings[this.key];
      this.updateInfo.path = this.updateInfo.path.replace("MediWorks", "Mediworks");
      let url = `http://${this.updateInfo.ip}:${this.updateInfo.port}/${this.updateInfo.path}/version?sn=${window.uid}`;
      reqGet(url, (err, data) => {
        if (!err) {
          let _v = data.split("-")[0].trim();
          if (this.version < _v) {
            this.isUpdateNeeded = true;
            window.uid = window.uid || "";
            !check &&
              this.$confirm(
                this.$t("langcfg.txtUpdateBeforePrompt", { version: _v }),
                this.$t("langcfg.txtPrompt"),
                {
                  confirmButtonText: this.$t("langcfg.txtOK"),
                  cancelButtonText: this.$t("langcfg.txtCancel"),
                  type: "warning"
                }
              ).then(() => {
                let urlVerify = `http://${this.updateInfo.ip}:${this.updateInfo.port}/${this.updateInfo.path}/verification?sn=${window.uid.trim()}`;
                console.log("start download", urlVerify);
                reqGetPip(urlVerify, fileSys.getUtilPath("verification"), (err) => {
                  if (isDefined(err)) {
                    this.notify(this.$t("langcfg.txtUpdateFailedAndNetError"), "", "error");
                  } else {
                    exec(
                      `node ${fileSys.getUtilPath("sslcrypto.js")}`,
                      { cwd: fileSys.getUtilPath() },
                      (err, data) => {
                        if (err) {
                          this.notify(this.$t("langcfg.txtUpdateFailedAndNetError"), "", "error");
                          return;
                        }
                        fileSys.getFileSize(fileSys.getUtilPath("verification"), (size) => {
                          console.log("size", size);
                          if (isDefined(size) && size > 100) {
                            // const sslcrypto = window.require(fileSys.getUtilPath('sslcrypto.node'))
                            // let verification = sslcrypto.DecryptFile(fileSys.getUtilPath('verification'))
                            let verification = string2json(data.toString());
                            if (!isDefined(verification)) {
                              this.notify(
                                this.$t("langcfg.txtUpdateFailedAndNetError"),
                                "",
                                "error"
                              );
                              return;
                            }
                            fileSys.deleteFile(fileSys.getUtilPath("verification"));
                            let arr = verification.body.split(" ");
                            let packagename = arr[arr.length - 1].trim();
                            let verifycode = arr[0].trim();
                            let urlZip = `http://${this.updateInfo.ip}:${this.updateInfo.port}/${this.updateInfo.path}/${packagename}.7z?sn=${window.uid.trim()}`;
                            let password = verification.password;
                            let params = {
                              lang: this.lang,
                              uid: window.uid.trim(),
                              shell: fileSys.getUtilPath("update.sh"),
                              options: [urlZip, verifycode, password]
                            };
                            fileSys.openUpdate(json2string(params));
                          }
                        });
                      }
                    );
                  }
                });
              });
          } else {
            this.isUpdateNeeded = false;
            !check && this.message(this.$t("langcfg.txtSoftwareIsLast"), "info");
          }
        } else {
          this.isUpdateNeeded = false;
          !check && this.message(this.$t("langcfg.txtNetError"), "error");
        }
      });
    },
    callDevTool() {
      this.dispCnt++;
      if (this.dispCnt >= 8) {
        this.dispCnt = 0;
        fileSys.openDevTools();
      }
    },
    closeUpdateTip() {
      this.$emit("close-update-tip");
      this.dialogVisible = false;
    },
    saveUpdateInfo(info) {
      window.updateSettings[this.key] = info;
      saveUpdateSettings(window.updateSettings);
      this.reqVersion();
    }
  },
  components: {
    Update
  },
  computed: {
    copyright() {
      return `Copyright © 2004-${this.endYear} Shanghai MediWorks Precision Instruments Co.,Ltd. `;
    },
    title() {
      if (this.isTopographyEnabled && this.isDryEyeEnabled) {
        return this.$t("langcfg.txtDryEyeAnalysis");
      } else {
        return this.isTopographyEnabled
          ? this.$t("langcfg.txtTopgraphyTester")
          : this.$t("langcfg.txtDryeyeTester");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.settings {
  // margin-top: 60px;
  // margin-right: 60px;
  font-size: 23px;
  color: white;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  // height: 1080px;
}
.logo-img {
  width: 350px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/About.vue